const isSaveShortcut = event => {
    if (event.defaultPrevented) {
        return false;
    }

    if (event.key !== 's' && event.key !== 'S') {
        return false;
    }

    if (event.shiftKey || event.altKey) {
        return false;
    }

    return event.metaKey || event.ctrlKey;
};

export const handleQuickSaveShortcut = event => {
    if (!isSaveShortcut(event)) {
        return;
    }

    const form = document.querySelector('form[data-quick-save]');

    if (!form) {
        return;
    }

    event.preventDefault();
    form.dispatchEvent(new Event('quicksave:submit'));
};
